import { FaAngleUp } from "react-icons/fa";
import './ScrollUpButton.css';

const ScrollUpButton = () => {
  const style = { color: "white", fontSize: "15px" };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="scrollToTop">
      <button onClick={scrollToTop}>
        <FaAngleUp style={style}/>
      </button>
    </div>
  );
};

export default ScrollUpButton;
